import React from 'react';
import styled from 'styled-components/macro';
import { useTranslate } from '../../contexts/languageContext';
import Logo from '../../containers/Logo';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import { getUrl } from '../../utils';
import { usePage } from '../../contexts/pageContext';
import constantes from '../../resources/constantes.json';
import { Link } from 'react-router-dom';
import { responsive } from '../../resources/constantes.json';
import { useEleccion } from '../../contexts/eleccionContext';
import { fmt } from '../../utils';
const FilaTablaTerritorios = props => {
  const t = useTranslate();
  const nomenclator = useNomenclator();
  const pageState = usePage();
  const elecOptions = useEleccion();
  const { urlInfo } = pageState;
  const { idHistorico } = urlInfo;
  const esHistorico = idHistorico != null;
  const ColorPartido =
    nomenclator.partidos[Number(props.territorio.codpar) - 1].color;
  const LogoPartido =
    nomenclator.partidos[Number(props.territorio.codpar) - 1].codpar;
  const NombrePar =
    nomenclator.partidos[Number(props.territorio.codpar) - 1].nombre;
  const eleccion = elecOptions.idEleccion;
  return (
    <ContainerFila>
      <Territorio>
        {!esHistorico ? (
          <SLink
            to={getUrl({
              id: nomenclator.ambitos[eleccion].find(
                y => y.c === props.territorio.amb
              ).i,
              eleccion,
              nomenclator,
              page: constantes.nombreEleccion[eleccion],
            })}
          >
            {props.territorio.nombre}
          </SLink>
        ) : (
          <p className="dataTitle" css="color: #222;"> {props.territorio.nombre}</p>
        )}
      </Territorio>
      <ContainerSegundaFila>
        <PartidoMasVotado>
          <p className="dataTitle pmv">Partido más votado</p>
          <DatosPartido>
            {props.hayGanadores && (
              <>
                <Color
                  color={
                    props.territorio.hayEmpate === '1'
                      ? '#F5AD00'
                      : ColorPartido
                  }
                />
                <StyledLogo
                  codpar={
                    props.territorio.hayEmpate === '1' ? '-1' : LogoPartido
                  }
                />
                <NombrePartido>{
                  props.territorio.hayEmpate === '1' ? t('empate') : NombrePar
                }</NombrePartido>
              </>
            )}
          </DatosPartido>
        </PartidoMasVotado>
        <MesasInformadas>
          <p className="dataTitle">Mesas informadas</p>
          <p className="dataPorc">{props.territorio.pmesesc}</p>
          <p className="dataABS">{fmt(props.territorio.mesesc)}</p>
        </MesasInformadas>
        <Votantes>
          <p className="dataTitle">Votantes</p>
          <p className="dataPorc">{props.territorio.pvotant}</p>
          <p className="dataABS">{fmt(props.territorio.votant)}</p>
        </Votantes>
      </ContainerSegundaFila>
    </ContainerFila>
  );
};

const StyledLogo = styled(Logo)`
  flex: 0 0 auto;
  width: 60px;
  background: grey;
`;

const ContainerFila = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 30px;
  background: #fff;
  width: 99%;
  border: 1px solid #d8d8d8;
  border-radius: 3px;
  flex-direction: column;
  @media screen and (max-width: ${responsive.mobile}px) {
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;

const ContainerSegundaFila = styled.div`
  display: flex;
  width: 98%;
  margin: auto;
  .dataABS{
    font-weight: 100;
  }
  .dataPorc{
    font-weight: 600;
  }
  .dataTitle{
    font-weight:700;
  }
  @media screen and (max-width: ${responsive.mobile}px) {
    flex-direction: column;
    .dataTitle{
      width:50%;
    }
    .dataTitle.pmv{
      width:25%;
    }
  }
  @media screen and (max-width:500px) {
    .dataTitle.pmv{
      width:50%;
    }
  }
`;

const Territorio = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding-left: 20px;
  align-items: center;
  flex: 0 0 95%;
  box-sizing: border-box;
`;

const NombrePartido = styled.div`
  width: calc(100% - 90px);  
  @media screen and (max-width:500px) {
    display:none;
  }
`;

const PartidoMasVotado = styled.div`
  width: 60%;
  @media screen and (max-width: ${responsive.mobile}px) {
    width: 100%;
    display: flex;
    align-items: center;
  }
  @media screen and (max-width:500px) {
    width: 100%;
    justify-content: space-between;
  }
  
`;

const MesasInformadas = styled.div`
  width: 25%;
  @media screen and (max-width: ${responsive.mobile}px) {
    width: 50%;
    display: flex;
    justify-content: space-between;
  }
  @media screen and (max-width:500px) {
    width: 100%;
  }
`;

const Votantes = styled.div`
  width: 15%;
  @media screen and (max-width: ${responsive.mobile}px) {
    width: 50%;
    display: flex;
    justify-content: space-between;
  }
  @media screen and (max-width:500px) {
    width: 100%;
  }
`;

const Color = styled(({ color, ...rest }) => <div {...rest} />)`
  width: 10px;
  height: 10px;
  background: ${({ color }) => (color ? color : '#fff')};
  border-radius: 50%;
  display: block;
`;

const DatosPartido = styled.div`
  display: flex;
  align-items: center;
`;

const SLink = styled(Link)`
  text-decoration: underline;
  color: #222;
  font-weight: 700;
  font-size: 14px;
`;
export default FilaTablaTerritorios;
